import core from '@gvdasa/gv-core';
import { Environment } from '../../../environment';



const Api: any = core.GVHttpClient(Environment);

export {Api}